import { useState, useEffect } from 'react';
import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged
} from 'firebase/auth';
import { auth } from '../firebase';
import { getUsuario } from '../services/firestore';

export function useAuth() {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        // Busca perfil completo no Firestore
        const perfil = await getUsuario(firebaseUser.uid);
        setUser({
          uid:      firebaseUser.uid,
          email:    firebaseUser.email,
          nome:     perfil?.nome || firebaseUser.displayName || firebaseUser.email,
          initials: (perfil?.nome || 'US').split(' ').map(n => n[0]).join('').slice(0,2).toUpperCase(),
          role:     perfil?.perfil || 'operacional',
          municipioId: perfil?.municipioId || process.env.REACT_APP_MUNICIPIO_ID,
        });
      } else {
        setUser(null);
      }
      setLoading(false);
    });
    return () => unsub();
  }, []);

  const login  = (email, pw) => signInWithEmailAndPassword(auth, email, pw);
  const logout = ()           => signOut(auth);

  return { user, loading, login, logout };
}
